
import { combineReducers } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import dashboardReducer from './slices/dashboardSlice';
import fileUploadReducer from './slices/fileUploadSlice';
import uploadedFilesReducer from './slices/uploadedFilesSlice';
import productReducer from './slices/productSlice';
import competitorsReducer from './slices/competitorsSlice';
import exportReducer from './slices/exportSlice';

export const rootReducer = combineReducers({
  auth: authReducer,
  dashboard: dashboardReducer,
  fileUpload: fileUploadReducer,
  uploadedFiles: uploadedFilesReducer,
  product: productReducer,
  competitors: competitorsReducer,
  export: exportReducer,
});
